import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ImpersonationBanner from './ImpersonationBanner';
import PhoneWidget from './phone/PhoneWidget';
import InstallPrompt from './common/InstallPrompt';
import { useAuthStore } from '../stores/authStore';
import { useThemeStore } from '../stores/themeStore';

function Layout() {
    const { user } = useAuthStore();
    const { applyTheme } = useThemeStore();

    useEffect(() => {
        // Apply full persisted theme (mode + all preset colors)
        applyTheme();
    }, [user?.business_id]);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <ImpersonationBanner />
                <Header />
                <div className="page-content animate-fade-in">
                    <Outlet />
                </div>
            </main>
            <PhoneWidget />
            <InstallPrompt />
        </div>
    );
}

export default Layout;

